const title = function (title) {
  document.title = title;
}

// 手机号验证
const is_phone = function (phone) {
  let br = true;
  if (!(/^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-9]|18[0-9]|19[8-9])[0-9]{8}$/.test(phone))) {
    br = false
  }
  return br
}
// 邮箱验证
const is_email = function (email) {
  let br = true;
  if (!(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(email))) {
    br = false
  }
  return br
}
// 非空验证
const is_text = function (text) {
  let br = true;
  if (!(/\S/.test(text))) {
    br = false
  }
  return br
}
// 密码验证
const is_password = function (text) {
  let br = true;
  if (!(/^[a-zA-Z0-9]{6,12}$/.test(text))) {
    br = false
  }
  if (!(/^(?![^a-zA-Z]+$)(?!\D+$)/.test(text))) {
    br = false
  }
  return br
}

const isMobile = function () {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

// 身份证验证
const is_card = function (code) {
  //身份证号合法性验证
  //支持15位和18位身份证号
  //支持地址编码、出生日期、校验位验证
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  var row = true;
  var msg = "验证成功";

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
    row = false, msg = "被保人身份证号格式错误";
  } else if (!city[code.substr(0, 2)]) {
    row = false, msg = "被保人身份证号地址编码错误";
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] != code[17].toUpperCase()) {
        row = false, msg = "被保人身份证号校验位错误";
      }
    }
  }
  return row;
}

// 存储信息
const set_data = function (key, val) {
  localStorage.setItem(key, JSON.stringify(val));
}
// 读取信息
const get_data = function (key) {
  return JSON.parse(localStorage.getItem(key));
}

// 超出省略
const slh = function (str, length) {
  if (str.length > length + 3) {
    str = str.substring(0, length) + "..."
  }
  return str;
}

// 获取当前日期
function getNowDate() {
  let date = new Date();
  let year = date.getFullYear()
  let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  return year + '-' + month + '-' + day
}

// 获取当前全部日期
function getNowTime() {
  let date = new Date();
  let dateTime
  let yy = date.getFullYear()
  let mm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
  return dateTime
}

// 获取当前年月
function getNowYearMonth() {
  let date = new Date();
  let year = date.getFullYear()
  let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
  return year + '-' + month
}

//获取某一天的日期
function getDate(num, str) {
  var today = new Date();
  var nowTime = today.getTime();
  var ms = 24 * 3600 * 1000 * num;
  today.setTime(parseInt(nowTime + ms));
  var oYear = today.getFullYear();
  var oMoth = (today.getMonth() + 1).toString();
  if (oMoth.length <= 1) oMoth = '0' + oMoth;
  var oDay = today.getDate().toString();
  if (oDay.length <= 1) oDay = '0' + oDay;
  return oYear + str + oMoth + str + oDay;
}

// 获取往前推m个月的日期
function getPreMonthDay(m) {
  var resultDate, year, month, day;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  day = currDate.getDate();
  var days = new Date(year, month, 0);
  days = days.getDate(); //获取当前日期中月的天数
  var year2 = year;
  var month2 = parseInt(month) - m;
  if (month2 <= 0) {
    year2 = parseInt(year2 - 1);
    month2 = 12 - (Math.abs(month2) % 12);
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }
  if (day2 < 10) {
    day2 = '0' + day2;
  }
  resultDate = year2 + '-' + month2 + '-' + day2;
  return resultDate;
}

//获取当前小时
function getNowHour() {
  let date = new Date();
  return date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
}

//获取当前分钟
function getNowMinute() {
  let date = new Date();
  return date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
}

//深拷贝对象
function deepClone(obj) {
  let _obj = JSON.stringify(obj), objClone = JSON.parse(_obj);
  return objClone
}

//数组是否包含id的对象
function arrayContainId(array, id) {
  for (var i = 0; i < array.length; i++) {
    let item = array[i]
    if (item.id === id) {
      return true
    }
  }
  return false
}

//秒数转时分秒
//type(0): 01:02:03
//type(1): 01:02′03″
//type(2): 01时02分03秒
function formatSeconds(value, type) {
  var secondTime = parseInt(value); // 秒
  var minuteTime = 0; // 分
  var hourTime = 0; // 小时
  if (secondTime >= 60) { //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime >= 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var secondStr = '';
  var minuteStr = '';
  var hourStr = '';
  if (secondTime < 10) {
    secondStr = '0' + secondTime
  } else {
    secondStr = secondTime
  }
  if (minuteTime < 10) {
    minuteStr = '0' + minuteTime
  } else {
    minuteStr = minuteTime
  }
  if (hourTime < 10) {
    hourStr = '0' + hourTime
  } else {
    hourStr = hourTime
  }
  //type(0): 01:02:03
  //type(1): 01:02′03″
  //type(2): 01时02分03秒
  var result = "";
  if (type === 0) {
    if (hourTime > 0) {
      result += hourStr + ':' + minuteStr + ':' + secondStr
    } else {
      result += minuteStr + ':' + secondStr
    }
  } else if (type === 1) {
    if (hourTime > 0) {
      result += hourStr + ':' + minuteStr + '′' + secondStr + '″'
    } else {
      result += minuteStr + '′' + secondStr + '″'
    }
  } else if (type === 2) {
    if (hourTime > 0) {
      result += hourStr + '时' + minuteStr + '分' + secondStr + '秒'
    } else {
      result += minuteStr + '分' + secondStr + '秒'
    }
  }
  return result;
}

/**
 * 四舍五入
 * @param num 小数
 * @param s 保留位数
 * @returns {string}
 */
function toFixed(num, s) {
  if (Object.is(parseFloat(num), NaN)) {
    return ''
  }
  //解决四舍六入问题，5强制加1进行四舍五入
  num += '';
  let numArray = num.split('.');
  if (numArray.length > 1) { //有小数部分
    let part2 = numArray[1];
    if (part2.length > s) {
      let last = part2.charAt(s)
      if (Number(last) === 5) {
        num = Number(num) + Math.pow(0.1, s + 1)
      }
    }
  }
  //-----------------------------
  num = parseFloat(num);
  let res = (Math.round((num + Number.EPSILON) * Math.pow(10, s)) / Math.pow(10, s)).toFixed(s);
  return Number(cutZero(res))
}

function cutZero(old) {
  old = '' + old
  //拷贝一份 返回去掉零的新串
  let newstr = old;
  //循环变量 小数部分长度
  let leng = old.length - old.indexOf(".") - 1
  //判断是否有效数
  if (old.indexOf(".") > -1) {
    //循环小数部分
    for (let i = leng; i > 0; i--) {
      //如果newstr末尾有0
      if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
        let k = newstr.lastIndexOf("0");
        //如果小数点后只有一个0 去掉小数点
        if (newstr.charAt(k - 1) == ".") {
          return newstr.substring(0, k - 1);
        } else {
          //否则 去掉一个0
          newstr = newstr.substring(0, k);
        }
      } else {
        //如果末尾没有0
        return newstr;
      }
    }
  }
  return old;
}

/**
 * @param {Object} 要转化的对象
 */
function getParamsString(obj) {
  let paramStr = ''
  for (let key of Object.keys(obj)) {
    let name = obj[key];
    if (paramStr === '') {
      paramStr += key + '=' + name
    } else {
      paramStr += '&' + key + '=' + name
    }
  }
  return paramStr
}

// 将el-icon的组件名称AbbbCddd转化为i-abbb-cddd形式
// 此前用switch做组件名时因关键字重复报错，所以格式统一加了前缀
// 例：Switch转换为i-switch，ArrowDownBold转换为i-arrow-down-bold
export function transElIconName(iconName) {
  return iconName.replace(/[A-Z]/g, (match) => match.toLowerCase())
}

/**
 * 检查输入框
 * @param {Object} value  值
 * @param {Object} number 小数位数
 */
function checkInput(value, number) {
  if (value === null) {
    value = ''
  } else {
    value += ''
  }
  if (number === 0) {
    if (value.indexOf('.') !== -1 || value.indexOf('。') !== -1) {
      value = value.substr(0, value.length - 1)
    }
    return (value.match(/^\d*(\.?\d{0,0})/g)[0]) || null
  } else if (number === 1) {
    return (value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
  } else if (number === 2) {
    return (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
  } else if (number === 3) {
    return (value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
  } else if (number === 4) {
    return (value.match(/^\d*(\.?\d{0,4})/g)[0]) || null
  }
}

//设置输入框只能输入大于0的正整数
function checkInputZero(value, number) {
  if (value === null) {
    value = ''
  } else {
    value += ''
  }
  if (number === 0) {
    if (value.indexOf('.') !== -1 || value.indexOf('。') !== -1) {
      value = value.substr(0, value.length - 1)
    }
    if (Number(value) === 0) {
      value = ''
    }
    return (value.match(/^\d*(\.?\d{0,0})/g)[0]) || null
  } else if (number === 1) {
    return (value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
  } else if (number === 2) {
    return (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
  } else if (number === 3) {
    return (value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
  } else if (number === 4) {
    return (value.match(/^\d*(\.?\d{0,4})/g)[0]) || null
  }
}

/**
 * 数组分成多个数组
 * @param array        要分割的数组
 * @param subGroupLength  每个数组的长度
 * @returns {*[]}
 */
function arraySplit(array, subGroupLength) {
  if (!array) {
    return []
  }
  let index = 0;
  let newArray = [];
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength));
  }
  return newArray;
}

//计算对象数组中某个属性合计
function countTotal(arr, keyName) {
  let $total = 0;
  $total = arr.reduce(function (total, currentValue, currentIndex, arr) {
    return currentValue[keyName] ? (total + currentValue[keyName]) : total;
  }, 0);
  return toFixed($total, 3);
}

//判断是否为空
function isEmpty(value) {
  return value === null || value === undefined || value.toString().trim() === '';
}

//判断输入框是否输入，不能为0
function isEmptyOrZero(value) {
  return value === null || value === undefined || value.toString().trim() === '' || Number(value) === 0;
}

//下载图片到本地
function saveImage(imgUrl, name) {
  let image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

    let a = document.createElement("a"); // 生成一个a元素
    let event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgUrl;
}

/**
 * 日期格式化
 * @param date0
 * @param isFull 是否完整时分秒
 * @returns {string}
 */
function formatDate(date0, isFull) {
  let date = new Date(date0);
  let YY = date.getFullYear() + '-';
  let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  if (isFull) {
    return YY + MM + DD + " " + hh + mm + ss;
  } else {
    return YY + MM + DD
  }
}

//获取后几天的日期
function getNextNumberDate(date, addDayCount) {
  let dd = new Date(date);
  dd.setDate(dd.getDate() + addDayCount);//获取AddDayCount天后的日期
  let y = dd.getFullYear();
  let m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
  let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
  return y + "-" + m + "-" + d;
}

//获取当前日期周一
function getFirstDayOfWeek(date) {
  let day = date.getDay() || 7;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day);
}

//获取当前日期周日
function getLastDayOfWeek(date) {
  let day = date.getDay() || 7;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 - day);
}

/**
 * 获取本月第一天
 */
const getNowMonthFirst = (date) => {
  date.setDate(1)
  return date
}

/**
 * 获取本月最后一天
 */
const getNowMonthLast = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export default {
  title, // 验证手机号
  is_phone, // 邮箱验证
  is_email, // 非空验证
  is_text, // 密码验证
  is_password, // 身份证验证
  is_card, // 存储信息
  set_data, // 读取信息
  get_data, // 超出省略
  slh, //是否是手机
  isMobile, //获取当前日期
  getNowDate, //获取当前时间
  getNowTime, //获取当前年月
  getNowYearMonth, //获取某一天的日期
  getDate, //获取往前推几个月的日期
  getPreMonthDay, getNowHour, getNowMinute, //深拷贝对象
  deepClone, //数组包含某个id
  arrayContainId, //格式化秒数
  formatSeconds, //四舍五入保留小数
  toFixed, //转化对象为请求参数
  getParamsString, //检查输入框
  checkInput, //设置输入框只能输入大于0的正整数
  checkInputZero, //数组分成多个数组
  arraySplit, //计算对象数组中某个属性合计
  countTotal, //判空
  isEmpty, //判空和0
  isEmptyOrZero, //下载图片
  saveImage,//
  formatDate,//
  getNextNumberDate,//
  getFirstDayOfWeek,//
  getLastDayOfWeek,//
  getNowMonthFirst,//
  getNowMonthLast,//
}
